gsap.registerPlugin(ScrollTrigger)

const productWrapper = document.querySelector('.product__info-wrapper');
const giftPrice = parseFloat(productWrapper.dataset.giftPrice);
let giftDiscount = 0;

const allBtnsQuantity = document.querySelectorAll('.variant-card-content button[data-operation]');
const allProgressBars = document.querySelectorAll('.progress-bar');
const allObjectivesItems = document.querySelectorAll('.objectives-item');

const bundleCompositionContainer = document.querySelector('.bundle-composition');

const bundleCountBags = document.querySelector('.bundle-informations .bags i');
const bundleCountBagsText = document.querySelector('.bundle-informations .bags span[data-singular]');
const bundleCountPellets = document.querySelector('.bundle-informations .pellets i');
const bundleCountPelletsText = document.querySelector('.bundle-informations .pellets span[data-singular]');
const bundlePricePerLiter = document.querySelector('.bundle-informations .price-per-liter');


// sub
const subContainer = document.querySelector('.subscription-container');
const choiceSubscribe = document.querySelector('.choice-subscribe');

const productInitialPrice = document.querySelector('.subscription-choices .initial-price');
const productSubComparePrice = document.querySelector('.choice-subscribe .compared-price'); 
const productSubPrice = document.querySelector('.choice-subscribe .initial-price'); 

const selectSub = document.querySelector('.allocations-block-content select.selling_plan_selector');
const allChoices = document.querySelectorAll('.sub-choice');
const allChoicesLabels= document.querySelectorAll('.sub-choice label.sub-circle');

// cta add to cart
const ctaAtcBtn = document.querySelector('.bundle-cta');
const atcPrice = document.querySelector('.atc-price');

let totalPrice = 0;
let finalPrice;
let count = 0;
let discountCoeff = 1;
let subDiscountCoeff = 1;

allBtnsQuantity.forEach(button => {
    button.addEventListener('click', () => {
        const card = button.closest('.variant-card');

        handleData(card, button.dataset.operation);
    })
})

function handleData(card, operation){
    const input = card.querySelector('input[type="number"]');
    const cardPrice = parseInt(card.dataset.price);

    let newInputValue;

    if(operation === 'plus'){

        // general
        totalPrice += cardPrice;
        count += 1;

        // input number
        newInputValue = parseInt(input.value) + 1;
    } 
    else if(operation === 'minus'){
        if(input.value == 0) return;

        // general
        totalPrice -= cardPrice;
        count -= 1;

        // input number
        newInputValue = parseInt(input.value) - 1;
    }

    input.value = newInputValue;

    if(newInputValue === 0){
        input.closest('.variant-card-content').classList.remove('active');
    } else{
        input.closest('.variant-card-content').classList.add('active');
    }

    updateProgressBar();
    setFinalPrices();
    updateBundleComposition(card);
    updateBundlnformations();
    updateAddToCartBtn();
    refreshStickyContent();
}

function updateAddToCartBtn(){
    const ctaText = ctaAtcBtn.querySelector('.bundle-cta-text');

    if(count === 0){
        ctaAtcBtn.classList.remove('bundle-filled');
        ctaAtcBtn.setAttribute('disabled', '');
        ctaText.innerText = ctaAtcBtn.dataset.emptyText;
        atcPrice.innerText = "";
    } else{
        ctaAtcBtn.classList.add('bundle-filled');
        ctaAtcBtn.removeAttribute('disabled');
        ctaText.innerText = ctaAtcBtn.dataset.atcStandardText;
        if(choiceSubscribe.classList.contains('active')){
            atcPrice.innerText = setPriceSubFinalCartValue(subDiscountCoeff);
        } 
        else{
            atcPrice.innerText = moneyFilter(((finalPrice / subDiscountCoeff + giftDiscount) * discountCoeff - giftDiscount));
        }
    }
}

function setFinalPrices(){
    const subscriptionSelect = document.querySelector('.selling_plan_selector');

    const subscriptionSelectedOption = subscriptionSelect.querySelector('option[selected]');

    if(choiceSubscribe.classList.contains('active')){
        subDiscountCoeff = 1 - parseInt(subscriptionSelectedOption.dataset.percent) / 100;
    } 
    else{
        subDiscountCoeff = 1;
    }
    
    finalPrice = totalPrice * subDiscountCoeff;

    updatePricePerLiter();
    updateSubBlockPrices();
}

function updateBundlnformations(){
    
    bundleCountBags.innerText = count;
    bundleCountBagsText.innerText = count > 1 ? bundleCountBagsText.dataset.plural : bundleCountBagsText.dataset.singular;

    const pelletsQty = count * 12;
    bundleCountPellets.innerText = pelletsQty;

    bundleCountPelletsText.innerText = count > 0 ? bundleCountPelletsText.dataset.plural : bundleCountPelletsText.dataset.singular;

}

function updatePricePerLiter(){
    const waterVolume = count * 9;

    const pricePerLiter  = moneyFilterWithoutCurrency(finalPrice * discountCoeff / waterVolume);

    if(count === 0){
        bundlePricePerLiter.innerText = '1,17';
    } else{
        bundlePricePerLiter.innerText = pricePerLiter;
    }
}

function updateBundleComposition(card){
    const input = card.querySelector('input[type="number"]');
    const nameItemComposition = document.querySelector(`.bundle-composition-item[data-name="${card.dataset.name}"]`);

    if(input.value == 0 && nameItemComposition){
        nameItemComposition.remove();
        return;
    }
    
    if(nameItemComposition){
        const number = nameItemComposition.querySelector('i');
        number.innerText = input.value;
    }
    else{
        const itemToAdd = document.createElement('div');
        itemToAdd.setAttribute('class', 'bundle-composition-item tw-inline-flex tw-font-bold');
        itemToAdd.dataset.name = card.dataset.name;
        itemToAdd.dataset.id = card.dataset.id;
    
        const html = `
            <div class="bundle-composition-item-title">
                <span>${card.dataset.title}</span>
            </div>
            <div class="bundle-composition-item-qty tw-flex tw-justify-center tw-items-center tw-px-2">
                <span>x</span><i>${input.value}</i>
            </div>
        `;
    
        itemToAdd.innerHTML = html;
    
        bundleCompositionContainer.append(itemToAdd);
    }
}

function updateProgressBar(){
    if(count < 4){
        allProgressBars[0].style.width = count * 100 / 4 + '%';
        allProgressBars[1].style.width = '0%';

        allObjectivesItems.forEach(item => {
            item.classList.remove('completed');
        })
    }
    else if (count === 4){
        allProgressBars[0].style.width = '100%';
        allProgressBars[1].style.width = '0%';
        allProgressBars[2].style.width = '0%';

        allObjectivesItems.forEach(item => {
            item.classList.remove('completed');
        })

        allObjectivesItems[0].classList.add('completed');
    }
    else if (count < 9 && count === 5){
        allProgressBars[1].style.width = '100%';
        allProgressBars[2].style.width = '0%';

        allObjectivesItems.forEach(item => {
            item.classList.remove('completed');
        })

        allObjectivesItems[0].classList.add('completed');
        allObjectivesItems[1].classList.add('completed');
    }
    else if (count > 5){
        allProgressBars[2].style.width = (count - 5) * 100 / (9 - 5) + '%';

        if(count >= 9){
            allObjectivesItems[2].classList.add('completed');
            giftDiscount = giftPrice;
        } else{
            allObjectivesItems[2].classList.remove('completed');
            giftDiscount = 0;
        }
    }

    if(count >= 5){
        discountCoeff = 0.9;
    } else{
        discountCoeff = 1;
    }
}

allChoicesLabels.forEach(label => {
    label.addEventListener('click', () => {
        const choice = label.closest('.sub-choice');
        updateSubChoice(choice);

        const sellingPlanId = choice.classList.contains('choice-one-time') ? "" : selectSub.value;
        updateSellingPlan(sellingPlanId);

        setFinalPrices();
        updateAddToCartBtn();
        refreshStickyContent();
    })
})

allChoices.forEach(choice => {
    choice.addEventListener('click', () => {
        choice.querySelector('label.sub-circle').click();
    })
})


function updateSubChoice(choice){

    allChoices.forEach(choiceItem => {
        choiceItem.classList.remove('active')
    });

    choice.classList.add('active');
}

function updateSellingPlan(id){
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');

    sellingPlanInput.value = id;
}

function updateSubBlockPrices(){
    if(count === 0){
        productInitialPrice.innerHTML = "";
        productSubPrice.innerHTML = "";
        productSubComparePrice.innerHTML = "";
    } 
    else{
        const subscriptionSelect = document.querySelector('.selling_plan_selector');
        const subscriptionSelectedOption = subscriptionSelect.querySelector('option[selected]');
        const currentSubCoeff = 1 - parseInt(subscriptionSelectedOption.dataset.percent) / 100;

        const initialPrice = moneyFilter(((finalPrice / subDiscountCoeff + giftDiscount) * discountCoeff - giftDiscount));
        const subPrice = setPriceSubFinalCartValue(currentSubCoeff);
        const subComparePrice = moneyFilter(((finalPrice / subDiscountCoeff + giftDiscount) * discountCoeff - giftDiscount));

        productInitialPrice.innerHTML = initialPrice;
        productSubPrice.innerHTML = subPrice;
        productSubComparePrice.innerHTML = subComparePrice;
    }
}

function setPriceSubFinalCartValue(subCoeff){
    let priceBundle = finalPrice * subCoeff / subDiscountCoeff;
    let priceToDisplay = 0;

    let pricePerItem = priceBundle / count;

    if(pricePerItem % 100 === 0){
        pricePerItem = parseFloat((pricePerItem / 100).toFixed());
    } else{
        pricePerItem = parseFloat((pricePerItem / 100).toFixed(2));
    }

    priceToDisplay = pricePerItem * count;

    priceToDisplay = (Math.ceil(((priceToDisplay + giftDiscount / 100) * discountCoeff - giftDiscount / 100) * 100) / 100).toFixed(2);
    
    // console.log(priceToDisplay);

    return priceToDisplay.toString().replace('.',',') + subContainer.dataset.currency;
}

function truncateToFixed(num, digits) {
    const str = num.toString();
    if (str.indexOf('.') !== -1) {
      const parts = str.split('.');
      const decimalPart = parts[1].substring(0, digits);
      return parseFloat(parts[0] + '.' + decimalPart).toFixed(digits);
    }
    return num.toFixed(digits);
  }


function moneyFilterWithoutCurrency(cents){
    let price;

    if(cents % 100 === 0){
        price = (cents / 100).toFixed().replace('.',',');
    } else{
        price = (cents / 100).toFixed(2).replace('.',',');
    }

    return price;
}

function moneyFilter(cents){
    let price;

    if(cents % 100 === 0){
        price = (cents / 100).toFixed().replace('.',',');
    } else{
        price = (cents / 100).toFixed(2).replace('.',',');
    }

    return price + subContainer.dataset.currency;
}

ctaAtcBtn.addEventListener('click', () => {
    ctaAtcBtn.classList.add('is-loading');

    // hideCart();

    const allBundleItems = document.querySelectorAll('.variant-bundles-block .bundle-composition-item');
    const bundleLength = allBundleItems.length;
    const sellingPlan = document.querySelector('input[name="selling_plan"]').value;

    const ctaFinalSubmission = document.querySelector('button.product-form__submit[type="submit"]');

    let itemsToAdd = [];

    // add all items to Cart except the last one
    allBundleItems.forEach((item, index) => {
        
        if(index + 1 <= bundleLength){
            const productData = {};

            productData.id = item.dataset.id;
            productData.quantity = parseInt(item.querySelector('i').innerText);
            productData.selling_plan = sellingPlan;
    
            itemsToAdd.push(productData);
        }
    })

    // gift
    if(count >= 9){
        let giftItem = {
            id:productWrapper.dataset.giftId,
            quantity:1
        }
        itemsToAdd.push(giftItem);
    }

    let formData = {
        items:itemsToAdd
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        
        // add last item to Cart by classic form submission (to open side Cart)

        const inputId = document.querySelector('.product-variant-id');
        const inputQuantity = document.querySelector('.quantity__input');

        const lastItemToAdd = allBundleItems[bundleLength - 1];

        inputId.value = lastItemToAdd.dataset.id;
        inputQuantity.value = lastItemToAdd.querySelector('i').innerText;

        // ctaFinalSubmission.click();
        // window.location.href = window.location.origin + '/checkout';

        ctaAtcBtn.classList.remove('is-loading');
    })

})

function hideCart(){
    const cart = document.body.classList.add('cart-hidden');
}

updateAddToCartBtn();

// sticky cta on mobile

const stickyBlock = document.getElementById('stickyBlock');
const stickyEnabled = false;
const bundleButtonParent = document.getElementById('bundleButtonParent');

const bundleContentToClone = document.getElementById('bundleStickyContentMobile');
const bundleContentContainer = document.querySelector('.sticky-bundle-content');

if(stickyEnabled){

    refreshStickyContent();

    const onMobile = window.innerWidth <= 767 || screen.width <= 767;

    const start = onMobile ? 'top bottom' : 'top+=100 bottom';
    const end = onMobile ? 'bottom 10%' : 'bottom+=100 20%';

    stickyBlock.classList.remove('hidden');
    stickyBlock.append(ctaAtcBtn);

    ScrollTrigger.create({
        trigger:bundleButtonParent,
        start:start,
        end:end,
        onEnter:() => {
            bundleButtonParent.append(ctaAtcBtn);
            stickyBlock.classList.add('hidden');
        },
        onEnterBack:() => {
            bundleButtonParent.append(ctaAtcBtn);
            stickyBlock.classList.add('hidden');
        },
        onLeave:() => {
            stickyBlock.append(ctaAtcBtn);
            stickyBlock.classList.remove('hidden');
        },
        onLeaveBack:() => {
            stickyBlock.append(ctaAtcBtn);
            stickyBlock.classList.remove('hidden');
        }
    })

    ScrollTrigger.create({
        trigger: '.footer-section',
        start:"top bottom",
        end:"top bottom",
        onEnter: () => {
            stickyBlock.classList.add('hidden');
        },
        onEnterBack:() => {
            stickyBlock.classList.remove('hidden');
        }
    })
}


function refreshStickyContent(){
    bundleContentContainer.innerHTML = "";

    const bundleStickyContent = bundleContentToClone.cloneNode(true);

    bundleContentContainer.innerHTML = bundleStickyContent.innerHTML;
}